import { Advertiser, Product } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from "../../Business/dto/ExternalSystemElement";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { DefaultInput } from "./DefaultInput";

interface ProductPickerProps {
    disabled?: boolean;
    filterData?: Advertiser;
    setSelectedProduct: (Product: Product) => void;
    required?: boolean;
    value: Product | undefined;
    allowNew?: boolean;
}

export const ProductPicker = (props: ProductPickerProps) => {
    const { t } = useTranslation();

    return (
        <>
            {!props.allowNew ?
                <>
                    <ExternalDataPicker
                            allowNew
                            disabled={props.disabled}
                            setSelectedData={props.setSelectedProduct}
                            placeholder={t("product")}
                            dataKey={DataKey.Product}
                            //body={body}
                            icon={faBuilding}
                            controlId="productPicker"
                            required={props.required}
                            value={props.value ? [props.value] : []}
                            filterData={props.filterData}
                        />
                </>
            :
                <>
                    <DefaultInput
                        required={props.required}
                        type="text"
                        iconKey="building"
                        placeholder={t("product")}
                        value={props.value ? props.value.name : ""}
                        onChange={(value) => {
                            if (props.setSelectedProduct)
                                props.setSelectedProduct({ id: "-1", name: value, mainSectorId: "" });
                        }}
                    />
                </>
            }
        </>
    );
}